<script>
    import FaIconPicker from "Components/global/FaIconPicker.vue";
    import isEmpty from "lodash/isEmpty";

    export default {
        props: ['lastOrder', 'lastId'],

        data() {
            return {
                id: this.lastId,
                order: this.lastOrder,
                icon_class: '',
                name: '',
                storedStatus: {},
                active: 1,
                edit: false
            }
        },

        mounted() {
            this.$event_bus.$on('add', () => {
                this.id = this.id +1;
                this.order  = this.order + 1;
                this.icon_class = '';
                this.name = '';
                this.storedStatus = {};
                this.edit = false;
                $("#custom-status-modal").modal('show');
            });

            this.$event_bus.$on('edit', (payload) => {
                this.id = payload.id;
                this.order = payload.order;
                this.icon_class = payload.icon_class.replace('zmdi zmdi-', '');
                this.name = payload.name;
                this.storedStatus = payload;
                this.edit = true
                $("#custom-status-modal").modal('show');
            });

            this.$event_bus.$on('success', () => {
                this.icon_class = '';
                this.name = '';
                this.active = 1;
            })
        },

        methods: {
            deleteStatus(){
                this.$event_bus.$emit('delete', this.storedStatus);
                $("#custom-status-modal").modal('hide');
            },

            customStatusSubmit() {
                if (!isEmpty(this.storedStatus)) {
                    this.active = this.storedStatus.active;
                }

                this.storedStatus = {};
                this.$event_bus.$emit('submit', {
                        'id': this.id,
                        'order': this.order,
                        'icon_class': this.icon_class,
                        'name': this.name,
                        'active': this.active
                });
            }
        },

        beforeUnmount() {
            this.$event_bus.$off('add');
            this.$event_bus.$off('edit');
            this.$event_bus.$off('success');
        },

        components: {
            FaIconPicker,
        },
    }
</script>

<template>
    <div id="custom-status-modal"  class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
        <div class="modal-dialog">
                <div class="panel panel-color panel-inverse m-0">
                    <div class="panel-heading">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h3 class="panel-title"><i class="zmdi zmdi-edit m-r-10"></i>{{ trans('settings.custom_status_create') }}</h3>
                    </div>
                </div>
                <div class="modal-content">
                    <form id="custom-status-form" class="responsive-form" autocomplete="off" @submit.prevent="customStatusSubmit()">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12">
                                    <div class="form-group">
                                        <label class="control-label">{{ trans('clients.name') }}</label>
                                        <input type="text" class="form-control" v-model="name" required>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="form-group">
                                        <label class="icon-label truncate m-b-0">{{ trans('global.icon') }}</label>
                                        <small class="text-muted m-b-10 truncate">{{ trans('settings.icon_description') }}</small>
                                        <fa-icon-picker v-model="icon_class"></fa-icon-picker>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <a v-if="edit" href="" class="btn btn-default  m-r-10" @click.prevent="deleteStatus()"><i class="fa fa-trash m-r-10"></i>{{ trans('global.delete') }}</a>
                            <button type="submit" class="btn btn-custom" >{{ trans('global.save') }}</button>
                        </div>
                    </form>
                </div>
        </div>
    </div>
</template>
